module.exports = __webpack_public_path__ + "images/花筑院子全景_06-1.jpg?v=531fa4a9";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/huazhu4/花筑院子全景_06-1.jpg
 ** module id = 77
 ** module chunks = 1 2
 **/